import React from 'react'
import parse from 'html-react-parser'
import Fade from 'react-reveal/Fade'

const PostImage = ({ image, wide }) => {
  return (
    <section className={`post-image${wide ? ' post-image--wide' : ''}`}>
      <Fade distance='40px' bottom>
        <div className="post-image__inner">
          { image?.mediaItemUrl && <img className="post-image__img" src={image.mediaItemUrl} alt='WHITEFOX Realestate' /> }
          { image?.localFile && <img className="post-image__img" src={image.localFile.publicURL} alt='WHITEFOX Realestate' /> }
          { image?.caption && <div className="post-image__caption">{ parse(image.caption) }</div> }
        </div>
      </Fade>
    </section>
  )
}

export default PostImage